export default __webpack_public_path__ + "static/skills-d962c779434124b19c085f6dc3e420fb.svg";